// This file contains the remaining tabs for ShareModal
// Import this into ShareModal.jsx

export const LinkTab = ({ shareUrl, qrCodeUrl, copied, copyLink, copyPrompt }) => (
  <div className="space-y-6 animate-fade-in">
    <div>
      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
        Link chia sẻ
      </label>
      <div className="flex gap-2">
        <input
          type="text"
          value={shareUrl}
          readOnly
          className="flex-1 px-4 py-3 bg-gray-50 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl text-gray-900 dark:text-gray-100 font-mono text-sm"
        />
        <button
          onClick={copyLink}
          className={`px-6 py-3 rounded-xl font-semibold transition-all ${
            copied
              ? 'bg-green-600 text-white'
              : 'bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white'
          }`}
        >
          {copied ? (
            <span className="flex items-center gap-2">
              <span className="material-symbols-rounded text-[20px]">check</span>
              Đã copy
            </span>
          ) : (
            <span className="flex items-center gap-2">
              <span className="material-symbols-rounded text-[20px]">content_copy</span>
              Copy
            </span>
          )}
        </button>
      </div>
    </div>

    <div>
      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
        Mã QR
      </label>
      <div className="flex flex-col items-center gap-4 p-6 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 rounded-2xl border border-gray-200 dark:border-gray-700">
        <img
          src={qrCodeUrl}
          alt="QR Code"
          className="w-48 h-48 rounded-xl shadow-lg"
        />
        <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
          Quét mã QR để truy cập prompt
        </p>
        <a
          href={qrCodeUrl}
          download="qr-code.png"
          className="px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white rounded-full font-semibold transition-all hover:scale-105"
        >
          Tải xuống QR
        </a>
      </div>
    </div>

    <button
      onClick={copyPrompt}
      className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 rounded-xl font-semibold text-gray-900 dark:text-gray-100 transition-all"
    >
      <span className="material-symbols-rounded">content_copy</span>
      Sao chép nội dung Prompt
    </button>
  </div>
);

export const EmbedTab = ({ pin, shareUrl, embedCopied, copyEmbed, downloadAsImage, previewRef }) => {
  const embedCode = `<iframe src="${shareUrl}" width="600" height="800" frameborder="0"></iframe>`;
  
  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
          Mã nhúng (Embed Code)
        </label>
        <div className="relative">
          <pre className="p-4 bg-gray-900 text-green-400 rounded-xl overflow-x-auto text-sm font-mono">
            {embedCode}
          </pre>
          <button
            onClick={copyEmbed}
            className={`absolute top-2 right-2 px-4 py-2 rounded-lg font-semibold transition-all ${
              embedCopied
                ? 'bg-green-600 text-white'
                : 'bg-gray-800 hover:bg-gray-700 text-white'
            }`}
          >
            {embedCopied ? 'Đã copy' : 'Copy'}
          </button>
        </div>
      </div>

      <div>
        <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
          Xem trước
        </label>
        <div
          ref={previewRef}
          className="p-6 bg-white dark:bg-gray-800 rounded-2xl border-2 border-gray-200 dark:border-gray-700 shadow-lg"
        >
          <div className="flex gap-4">
            <img
              src={pin.image}
              alt={pin.title}
              className="w-32 h-32 object-cover rounded-xl"
            />
            <div className="flex-1">
              <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-2">
                {pin.title}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400 line-clamp-3">
                {pin.prompt}
              </p>
              <div className="flex gap-2 mt-3">
                {pin.tags?.slice(0, 3).map((tag, index) => (
                  <span
                    key={index}
                    className="px-3 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 text-xs rounded-full"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={downloadAsImage}
        className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-green-600 to-teal-600 hover:from-green-700 hover:to-teal-700 text-white rounded-xl font-semibold transition-all hover:scale-105 shadow-lg"
      >
        <span className="material-symbols-rounded">download</span>
        Tải xuống dưới dạng ảnh
      </button>
    </div>
  );
};
